import processContent from '@content/process.yaml'
import type { ProcessContent } from '@/types/content'

const content = processContent as unknown as ProcessContent

export function Process() {
  return (
    <section id="process" className="sl">
      <div className="ey reveal">{content.eyebrow}</div>
      <h2 className="sh2 reveal d2" dangerouslySetInnerHTML={{ __html: content.headline }} />
      <div className="process-wrap">
        {content.steps.map((step) => (
          <div key={step.num} className="ps reveal">
            <div className="ps-num">{step.num}</div>
            <div>
              <h3 className="ps-title">{step.title}</h3>
              <p className="ps-body">{step.body}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
